import { colors } from 'settings/style';
import styled from 'styled-components';

export const SocialFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #eaecf0;
`;

export const InviteRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 15px 0px;
`;

export const ManageBookingsRow = styled(InviteRow)`
  margin-top: 0;
  padding-top: 16px;
  border-top: 1px solid #eaecf0;
`;

export const InviteLabel = styled.span`
  font-weight: 600;
  color: ${colors.grey900};
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

export const InviteButton = styled.button`
  border: 1px solid #d0d5dd;
  background: #fff;
  color: ${colors.grey900};
  font-weight: 600;
  border-radius: 10px;
  padding: 8px 18px;
  cursor: pointer;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    border-color: #475467;
    color: #475467;
  }
`;

export const ShareRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const ShareLabel = styled.span`
  font-weight: 600;
  color: ${colors.grey900};
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

export const ShareIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  a {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f2f4f7;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #667085;
    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
      background: #e4e7ec;
      color: ${colors.grey900};
    }

    i {
      font-size: 14px;
    }
  }
`;

export const DonateButton = styled.button`
  border: 1px solid #d0d5dd;
  background: #fff;
  color: ${colors.grey900};
  font-weight: 600;
  border-radius: 10px;
  padding: 8px 18px;
  cursor: pointer;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

  &:hover {
    border-color: #475467;
    color: #475467;
  }
`;
